



















import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import PaymentMethodMixin from './PaymentMethodMixin';
import VatsAPI from '@/Shared/VatsAPI';
import { PaymentSubmission } from '@/Payment/PaymentSubmission';
import { PaymentResult } from '@/Payment/PaymentResult';
import { PaymentSource, HostedPaymentType, IFrameType } from '@/Payment/Enums';
import PaymentSubmit from './PaymentSubmit.vue';
import { HostedCheckoutRequest } from '@/Payment/HostedCheckoutRequest';
import FormPayment from './HostedPaymentTypes/FormPayment.vue';

const component = mixins(LocationBasedMixin, PaymentMethodMixin).extend({
    components: {
        FormPayment,
        VantivIFrame: () => import('./HostedPaymentTypes/Vantiv/VantivIFrame.vue'),
    },
    computed: {
        submission(): PaymentSubmission<any> {
            return {
                toPay: this.recordsToPay,
                customer: this.customer,
                paymentMethod: {
                    paymentMethod: this.method,
                    paymentSource: this.source,
                    // Will be replaced by the controller method, but cannot be left empty
                    // or it will fail validation
                    callbackController: 'replaceme',
                }
            };
        },
    },
    data() {
        return {
            hostedCheckout: null as HostedCheckoutRequest | null,
            HostedPaymentType,
            IFrameType,
        };
    },
    mounted() {
        const payButton = this.$refs.payButton as Element;
        payButton.scrollIntoView();
    },
    methods: {
        async afterSubmit(paymentResult: PaymentResult) {
            this.hostedCheckout = paymentResult.hostedCheckoutRequest;
        }
    }
});

export default component;
